import { Button } from "react-bootstrap";

const GoalTrackButton = ({ element, selected, onClick, disabled }) => {
  return (
    <div
      className="goal-track rate d-flex align-items-center justify-content-center rounded-circle themeBlue"
      style={{ backgroundColor: selected ? "#ac5c9a" : "#fff" }}
    >
      <Button style={{ border: "none" }} variant="transparent" onClick={onClick} disabled={selected || disabled}>
        {element}
      </Button>
    </div>
  );
}

export default GoalTrackButton;